import axios from "axios";
import { useAuth } from "@clerk/react";
import { useCallback } from "react";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const publicApi = axios.create({ baseURL: API });

export const assetUrl = (path) => (path ? `${BACKEND_URL}${path}` : null);

export const errorMessage = (e) => {
  const d = e?.response?.data?.detail;
  if (Array.isArray(d)) return d.map((x) => x.msg).join(", ");
  return d || e?.message || "Something went wrong";
};

export function useAuthedRequest() {
  const { getToken } = useAuth();
  return useCallback(
    async (method, url, data, config = {}) => {
      const token = await getToken();
      const res = await axios({
        method, url: `${API}${url}`, data, ...config,
        headers: { ...(config.headers || {}), Authorization: `Bearer ${token}` },
      });
      return res.data;
    },
    [getToken]
  );
}
